<div class="language-picker">
  <a *ngFor="let lang of languages|async" (click)="changeLanguage(lang.code)"
     [class.active]="lang.active" title="{{lang.code}}">
    <img src="./assets/images/flags/{{lang.code}}.gif" alt="">
  </a>
</div>
